/**
 * Shell shared by every unauthenticated page (login, accept-invite,
 * forgot-password, reset-password) so the four look like one family.
 *
 * Markup lifted verbatim from `LoginPage` (admin-arch §7.2, design §6.18):
 * narrow centred container, brand `<h1>`, dimmed one-line purpose, bordered
 * card. `component="section"` keeps the card a landmark rather than a `div`.
 */

import type { ReactNode } from 'react';
import { Container, Paper, Text, Title } from '@mantine/core';

interface AuthPageShellProps {
  /** One line under the brand heading explaining what this page is for. */
  subtitle: string;
  children: ReactNode;
}

export function AuthPageShell({ subtitle, children }: AuthPageShellProps) {
  return (
    <Container size={420} my="xl">
      <Title ta="center" order={1} fz={28}>
        musichead — Admin
      </Title>
      <Text c="dimmed" size="sm" ta="center" mt="xs">
        {subtitle}
      </Text>

      <Paper withBorder shadow="sm" p="xl" mt="lg" radius="md" component="section">
        {children}
      </Paper>
    </Container>
  );
}
